import { Link } from "react-router";
import { baseURL } from "../constants/config";

export const Page404: React.FC = () => {
  return (
    <div className="w-100 text-center p-5">
      <div className="text-primary" style={{ fontSize: '6em' }}>404</div>
      <h1>Page not found!</h1>
      <p>The page you are looking for does not exist.</p>
      <p><Link className="btn btn-primary" to={baseURL}>GO TO HOME</Link></p>
    </div>
  );
};

export default Page404;
